var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.792,
    height: 16.443,
    viewBox: "0 0 18.792 16.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12439",
    "data-name": "Group 12439",
    transform: "translate(0 -3.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_16",
    "data-name": "Polygon 16",
    d: "M8.528,1.519a1,1,0,0,1,1.736,0l7.673,13.428a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z",
    transform: "translate(18.792 19.665) rotate(180)",
    fill: "#d00917"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrowRed.5f2a7cf338aeae14d2d072fe8b68c0c7.svg";
export { ForwardRef as ReactComponent };